import getEnvVar from './getEnvVar';

export const isTelemetryEnabled = (): boolean => {
  return getEnvVar('REACT_APP_IS_TELEMETRY_ENABLED', 'false') === 'true';
};
